import React from 'react'; // This component is a stub to support React Native web

export default function PagerAndroid() {
  return React.createElement("p", null, "PagerAndroid is not supported on web.");
}